import React, { useEffect, useState } from 'react';
export function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToCTA = () => {
    document.getElementById('cta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300" style={{
    backgroundColor: scrolled ? 'rgba(11, 25, 41, 0.97)' : 'rgba(11, 25, 41, 0.85)',
    backdropFilter: 'blur(12px)',
    borderBottom: scrolled ? '1px solid rgba(201,168,76,0.3)' : 'none'
  }} data-id="element-144">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between" data-id="element-145">
        <div className="flex items-center gap-2" data-id="element-146">
          <PhoenixIcon className="w-7 h-7" data-id="element-147" />
          <span className="font-heading font-bold text-lg tracking-wide" style={{
          color: '#C9A84C'
        }} data-id="element-148">
            Método Fénix 45+
          </span>
        </div>
        <button onClick={scrollToCTA} className="hidden sm:flex items-center gap-2 px-5 py-2 rounded font-body font-bold text-sm transition-all duration-200 hover:scale-105" style={{
        backgroundColor: '#C9A84C',
        color: '#0F2540'
      }} data-id="element-149">
          Quiero Reinventarme →
        </button>
      </div>
    </nav>;
}
function PhoenixIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-150">
      <path d="M20 4C20 4 12 10 12 18C12 22.4 15.6 26 20 26C24.4 26 28 22.4 28 18C28 10 20 4 20 4Z" fill="#C9A84C" opacity="0.9" data-id="element-151" />
      <path d="M8 20C8 20 4 16 6 12C8 8 14 10 14 10C14 10 10 14 12 18C13.2 20.8 16 22 16 22L8 20Z" fill="#C9A84C" opacity="0.7" data-id="element-152" />
      <path d="M32 20C32 20 36 16 34 12C32 8 26 10 26 10C26 10 30 14 28 18C26.8 20.8 24 22 24 22L32 20Z" fill="#C9A84C" opacity="0.7" data-id="element-153" />
      <path d="M20 26C20 26 16 30 18 34C19 36 20 36 20 36C20 36 21 36 22 34C24 30 20 26 20 26Z" fill="#C9A84C" opacity="0.8" data-id="element-154" />
      <circle cx="20" cy="18" r="3" fill="#FAF7F2" opacity="0.9" data-id="element-155" />
    </svg>;
}